import React, { useState } from "react";
import { Box, Tabs, Tab, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BadgesTab from "./BadgesTab";
import CertificatesTab from "./CertificatesTab";
import CreateCertificateModal from "./CreateCertificateModal";
import CreateBadgeModal from "./CreateBadgeModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const BadgesAndCertificates = () => {
  const [tabValue, setTabValue] = useState(0);
  const [openBadgeModal, setOpenBadgeModal] = useState(false);
  const [openCertificateModal, setOpenCertificateModal] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <div className="page-wrapper card">
      <Box sx={{ m: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="badges and certificates tabs"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
              },
              "& .Mui-selected": {
                color: "#0555c8",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#0555c8",
              },
            }}
          >
            <Tab label="Badges" />
            <Tab label="Certificates" />
          </Tabs>

          {tabValue === 0 && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setOpenBadgeModal(true)}
              sx={{
                backgroundColor: "#0555c8",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#043c99",
                },
              }}
            >
              Create Badge
            </Button>
          )}

          {tabValue === 1 && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setOpenCertificateModal(true)}
              sx={{
                backgroundColor: "#0555c8",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#043c99",
                },
              }}
            >
              Create Certificate
            </Button>
          )}
        </Box>

        <TabPanel value={tabValue} index={0}>
          <BadgesTab />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <CertificatesTab />
        </TabPanel>

        <CreateBadgeModal
          open={openBadgeModal}
          onClose={() => setOpenBadgeModal(false)}
        />

        <CreateCertificateModal
          open={openCertificateModal}
          onClose={() => setOpenCertificateModal(false)}
        />
      </Box>
    </div>
  );
};

export default BadgesAndCertificates;
